<template>
  <div
    :class="[
      'tw-text-center tw-bg-gray-200 tw-rounded-full tw-relative tw-inline-flex tw-items-center tw-overflow-hidden tw-justify-center',
      photoSize
    ]"
  >
    <img
      v-show="uPhoto.length && !loadingPhoto"
      :title="self ? 'me': userFirstName"
      :alt="self ? 'me': userFirstName | firstLetter"
      :class="[
        'tw-block tw-rounded-full tw-text-center tw-align-middle tw-uppercase tw-leading-relaxed tw-mx-auto',
        `${logo ? 'tw-object-contain tw-bg-app-light-blue': 'tw-object-cover tw-bg-gray-500'}`,
        photoSize,
      ]"
      :src="uPhoto"
      ref="photo"
      decoding="async"
      async
      @load="loadingPhoto = false"
      @error="loadingPhoto = true"
    >
    <span
      v-show="uPhoto.length === 0 || loadingPhoto"
      :class="[
        'tw-block tw-text-black tw-rounded-full tw-text-center tw-uppercase tw-leading-relaxed opacity-31',
      ]"
      style="font-size: 70%;"
    >
      {{ userFirstName | firstLetter }}{{ userLastName | firstLetter }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserPhoto',
  props: {
    photo: {
      type: String,
      default: '',
    },
    userName: {
      type: Object,
      default: () => ({
        name: '',
        middle: '',
      }),
    },
    self: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: Boolean,
      default: false,
    },
    photoSize: {
      type: String,
      default: 'w-56 h-56',
    },
  },
  data() {
    return {
      photoSrc: '',
      loadingPhoto: false,
      uPhoto: this.userPhoto(this.photo),
      userFirstName: this.userName.name,
      userLastName: this.userName.middle || '',
    };
  },
  watch: {
    async refreshMyPhoto() {
      await this.$nextTick();
      await this.fetchMyPhoto();
      await this.$nextTick();
    },
    photo(newVal) {
      this.uPhoto = this.userPhoto(newVal);
    },
  },
  computed: {
    textPadding() {
      return 'tw-pt-2 tw-my-2';
    },
    ...mapState({
      refreshMyPhoto: (state) => state.Ui.refreshMyPhoto,
    }),
  },
  methods: {
    async fetchMyPhoto() {
      if (this.self) {
        this.uPhoto = '';
        const user = await this.$store.dispatch('getUserData', this.$store.state.User.id) || {};
        this.uPhoto = this.userPhoto(user.photo);
        this.userFirstName = user.name;
        this.userLastName = user.last_name;
      }
    },
  },
  async mounted() {
    await this.$nextTick();
    await this.$nextTick();
    await this.$nextTick();
    this.uPhoto = this.userPhoto(this.photo);
    // generate blob
    // because it is usually cached
    // instead of getting from the server every time
    // DOES NOT WORK
    if (this.self) {
      await this.fetchMyPhoto();
    }

    if (this.photo.length === 0 || !this.$refs.photo) return false;
    this.loadingPhoto = true;

    this.$refs.photo.onloadend = () => {
      this.loadingPhoto = false;
    };

    this.loadingPhoto = false;
    return true;
  },
};
</script>

<style lang="postcss">
/* overide the default .tw-rounded-full */
.tw-rounded-10--force,
.tw-rounded-10--force.--force-children > * {
  border-radius: 10px !important;
}
.tw-rounded-3--force,
.tw-rounded-3--force.--force-children > * {
  border-radius: 3px !important;
}

</style>
